import React from "react";
import AppText from "./AppText";
import { makeUrl } from "../../../api/makeUrl";
import useAuthenticationStore from "./Store";
import { useAuthenticationConfiguration } from "./Configuration";

import "./Links.css";

type ActiveLogout = {
    Logout: (isUserInitiated: boolean) => void;
};

declare global {
    interface Window {
        ActiveLogout?: ActiveLogout;
    }
}

interface LinksParameters {
  forceIsLogin?: boolean;
}

const Links: React.FC<LinksParameters> = ({ forceIsLogin }) => {
    const { state, isLogin } = useAuthenticationStore();
    const { isModal } = useAuthenticationConfiguration();

    const returnToLogin = async () => {
        window.location.href = makeUrl(`~/identityserver/local/auth?signInId=${state.signInId}`);
        return false;
    };

    const logout = async () => {
        window.ActiveLogout?.Logout(true);
        return false;
    };

    const goBack = async () => {
        const url = state.redirectUrl && makeUrl(state.redirectUrl);
        window.location.href = !url || url.toLowerCase().includes("mfa") ? makeUrl("~/") : url;
        return false;
    };

    return (
        !isModal && (
            <>
            {(forceIsLogin || isLogin()) && (
                <div id="links">
                    <a href="#" className="editor-controls-button text-button" onClick={returnToLogin}>
                        <AppText textKey="links-return-to-login" />
                    </a>
                </div>
            )}
            {!(forceIsLogin || isLogin()) && ( //only appears when you visit /UserProfile/MfaSettings directly
                <div id="links" className="no-modal">
                    <a href="#" className="editor-controls-button text-button" onClick={goBack}>
                        <AppText textKey="links-back" />
                    </a>{" "}
                    <a href="#" className="editor-controls-button text-button" onClick={logout}>
                        <AppText textKey="links-logout" />
                    </a>
                </div>
            )}
            </>
        )
    );
};

export default Links;
